var PANEL_OFFSET = 0;

;(function ($) {
    $.fn.appendAjaxOverlay = function (method) {
        if (method == 'add') {
            $(this).append('<span class="ajax-loading -appearance"></span>');
            var preloader = $(this).children('.ajax-loading')
            setTimeout(function () {
                if(preloader.length) {
                    preloader.removeClass('-appearance');
                }
            }, 100);
        } else if (method == 'remove') {
            $(this).find('.ajax-loading').remove();
        }
    };
})(jQuery);

$(function(){
    /* bitrix panel offset */
    function getPanelHeight() {
        return $('#panel').height();
    }
    if($('#panel').length) {
        BX.addCustomEvent('onTopPanelCollapse', BX.delegate(function(data){
            PANEL_OFFSET = getPanelHeight();
        }, this));
        BX.addCustomEvent('onTopPanelFix', BX.delegate(function(data){
            PANEL_OFFSET = getPanelHeight();
        }, this));
    }

    // recaptcha
    if(typeof window.Recaptchafree !== 'undefined') {
        window.Recaptchafree.check();
    }

    // preloading
    var preTimer = 0;
    function checkSVG() {
        var svgContainers = $('svg.icon use');
        for (var i = 0; i < svgContainers.length; i += 1) {
            var container = $(svgContainers[i]),
                id = container.attr('xlink:href');
            if(!$(id).length) {
                return false;
            }
        }
        return true;
    }
    function preWorker() {
        clearTimeout(preTimer);
        if(!checkSVG()) {
            preTimer = setTimeout(function () {
                preWorker()
            }, 500);
            return;
        }
        $('body').removeClass('preloading');
    }
    $(document).ready(function() {
        preWorker();
    });

    // lazyload
    try {
        lazyload(null, {'rootMargin': '4000px'});
    } catch (e) {}
    
    //reports
    var rContainer = $('.js-report-form');
    if(rContainer.length) {
        // init
        var REPORT_PROFILE = REPORT_PROFILE || {vars: {receiver: {}, timer: {}}, func: {}},
            ajaxParams = {
                type: 'POST',
                url: '/ajax/report.php',
                data: {},
                dataType: 'json',
                async: true,
                cache: false,
                timeout: 10000
            };

        // timers
        REPORT_PROFILE.vars.timer.send_report = 0;

        // functions
        REPORT_PROFILE.func.messagesClear = function (messagesBlock) {
            messagesBlock.html('');
        };
        REPORT_PROFILE.func.message = function (messagesBlock, message, type) {
            type = type || 'ERROR';

            if(type == 'ERROR') {
                messagesBlock.append('<p class="errortext">'+message+'</p>');
            } else {
                messagesBlock.append('<p class="notetext">'+message+'</p>');
            }
        };
        REPORT_PROFILE.func.responseMessages = function (messagesBlock, response) {
            if(response.ERRORS && response.ERRORS.length) {
                REPORT_PROFILE.func.message(messagesBlock, response.ERRORS_HTML || response.ERRORS.join('<br/>'));
            }
            if(response.NOTES && response.NOTES.length) {
                REPORT_PROFILE.func.message(messagesBlock, response.NOTES_HTML || response.NOTES.join('<br/>'), 'NOTE');
            }
        };

        // events
        $(document).on('click', '.js-report-open', function (e) {
            e.preventDefault();
            var pid = parseInt($(this).data('pid')),
                input = rContainer.find('.js-profile-id');
            if(!isNaN(pid) && pid < 0) {
                pid = 0;
            }
            if(input.length) {
                input.val(pid);
            }
        });
        var form = rContainer.find('form'),
            messagesBlock = rContainer.find('.form-messages');
        if(form.length) {
            var commentBlock = form.find('.js-comment');
            rContainer.on('click', '.js-send-report', function (e) {
                e.preventDefault();
                form.submit();
            });
            rContainer.on('change', '.js-other-check', function (e) {
                e.preventDefault();
                if($(this).prop('checked')) {
                    commentBlock.show();
                } else {
                    commentBlock.hide();
                }
            });
            form.on('submit', function (e) {
                e.preventDefault();
                REPORT_PROFILE.func.messagesClear(messagesBlock);
                form.appendAjaxOverlay('add');
                clearTimeout(REPORT_PROFILE.vars.timer.send_report);
                REPORT_PROFILE.vars.timer.send_report = setTimeout(function () {
                    ajaxParams.dataType = 'json';
                    ajaxParams.data = form.serialize();
                    $.ajax(ajaxParams).done(function(response) {
                        if(response) {
                            REPORT_PROFILE.func.responseMessages(messagesBlock, response);
                            if(response.SUCCESS == 'Y') {
                                form.hide();
                                //$(document).trigger('vok_OnSendReportSuccess');
                            }
                        }
                    }).fail(function(){
                        //$(document).trigger('vok_OnSendReportError');
                    }).always(function(){
                        form.appendAjaxOverlay('remove');
                    });
                }, 500);
            });
            /*$(document).mouseup(function (e) {
             if (rContainer.parent().has(e.target).length === 0){
             rContainer.hide();
             }
             });*/
        }
    }

    $('.icon.go-top').click(function(e) {
        e.preventDefault();
        $('body').stop().animate({scrollTop:0}, '500', 'swing');
        $('html').stop().animate({scrollTop:0}, '500', 'swing');
    });

    var overlay = $('.overlay-bg'),
        menuBtn = $('.menu-btn'),
        menu = $('.menu-wrapper');
    if(menuBtn.length) {
        menu.show();

        menuBtn.click(function(e) {
            e.preventDefault();
            if(menuBtn.hasClass('-active')) {
                menuLeftHide();
            } else {
                menuLeftShow()
            }
        });

        overlay.click(function (e) {
            menuLeftHide();
        });

        function menuLeftShow() {
            menuBtn.addClass('-active');
            overlay.show().delay(500).addClass('-active');
            menu.addClass('-active');
        }

        function menuLeftHide() {
            menuBtn.removeClass('-active');
            overlay.removeClass('-active').delay(1000).hide();
            menu.removeClass('-active');
        }

        if($.fn.swipe) {
            $('body .overlay-bg').swipe( {
                swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
                    if(distance > 100) {
                        switch (direction) {
                            case 'left':
                                menuLeftHide();
                                break;
                            case 'right':
                                menuLeftShow();
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        }
    }
    
    var navbar = $('.header');
    if(navbar.length) {
        var win = $(window),
            panel = $('#bx-panel');
        navbar.addClass('-static-top');
        win.scroll(function (e) {
            var scroll = win.scrollTop(),
                navHeight = navbar.height(),
                fixedAllow = panel.length && !panel.hasClass('bx-panel-fixed');
            if(fixedAllow && (scroll > PANEL_OFFSET + navHeight)) {
                navbar.removeClass('-static-top');
                navbar.addClass('-fixed-top');
            } else {
                navbar.removeClass('-fixed-top');
                navbar.addClass('-static-top');
            }
        });

        //$('.mini-logo').removeAttr('style');
    }

    var sortDropdown = $('.js-sort');
    if(sortDropdown.length) {
        var dropdown = sortDropdown.children('.dropdown-menu'),
            trigger = sortDropdown.children('.dropdown-toggle');
        trigger.click(function (e) {
            e.preventDefault();
            dropdown.toggle();
        });
        $(document).mouseup(function (e) {
            if (sortDropdown.has(e.target).length === 0){
                dropdown.hide();
            }
        });
    }

    function shuffleProfiles() {
        $('ul.shuffle, div.shuffle').each(function () {
            var container = $(this),
                items_top = container.children('li.group_top, div.group_top'),
                items_normal = container.children('li.group_normal, div.group_normal');
            while (items_top.length) {
                container.append(items_top.splice(Math.floor(Math.random() * items_top.length), 1)[0]);
            }
            while (items_normal.length) {
                container.append(items_normal.splice(Math.floor(Math.random() * items_normal.length), 1)[0]);
            }
            container.removeClass('shuffle');

            // fix
            var items = container.children('li.group_top, div.group_top, li.group_normal, div.group_normal'),
                index = 1,
                count = items.length,
                sliderPos = 6;
            while (items.length) {
                container.append(items.splice(0, 1)[0]);
                if(index == sliderPos || (index < sliderPos && index == count)) {
                    container.append(container.children('.clearfix'));
                    container.append(container.children('.special-block'));
                }
                index++;
            }
            container.append(container.children('.page-navigation'));
        });
    }

    if(window.location.href.indexOf('sort=') < 0) {
        shuffleProfiles();
    }
});